import { render, staticRenderFns } from "./Substitution.vue?vue&type=template&id=05e997ef&scoped=true&"
import script from "./Substitution.vue?vue&type=script&lang=js&"
export * from "./Substitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e997ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e997ef')) {
      api.createRecord('05e997ef', component.options)
    } else {
      api.reload('05e997ef', component.options)
    }
    module.hot.accept("./Substitution.vue?vue&type=template&id=05e997ef&scoped=true&", function () {
      api.rerender('05e997ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/Modal/Substitution.vue"
export default component.exports